import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loadAnalyticsRequest } from "../../../store/slices/analyticsSlice";
import { getDateRangeTimestamps } from "../../../utils/analyticsUtils";
import { calculateAllMetrics } from "../utils/analyticsCalculations";

export const useDashboardData = () => {
    const dispatch = useDispatch();
    const isConnected = useSelector((state) => state.whatsapp.isConnected);
    const isPaid = useSelector((state) => state.whatsapp.isPaid);
    const wabaLoading = useSelector((state) => state.whatsapp.wabaLoading);
    const wabaError = useSelector((state) => state.whatsapp.wabaError);
    const phones = useSelector((state) => state.whatsapp.phones);
    const wabaAccounts = useSelector((state) => state.whatsapp.wabaAccounts);
    const { dailyData: analyticsData } = useSelector((state) => state.analytics);

    const [selectedNumber, setSelectedNumber] = useState("1");
    const [showConnect, setShowConnect] = useState(false);

    useEffect(() => {
        dispatch({ type: "FETCH_WABA_IDS" });
    }, [dispatch]);

    useEffect(() => {
        if (phones.length > 0) {
            setSelectedNumber(phones[0].id);
        } else {
            setSelectedNumber("");
        }
    }, [phones]);

    useEffect(() => {
        if (isConnected && wabaAccounts.length > 0) {
            const wabaId = wabaAccounts[0]?.wabaId;
            if (wabaId) {
                const duration = getDateRangeTimestamps(30);
                dispatch(
                    loadAnalyticsRequest({
                        wabaId,
                        duration,
                    })
                );
            }
        }
    }, [dispatch, isConnected, wabaAccounts]);

    const { totalSent, totalDelivered, deliveryRate } = calculateAllMetrics(analyticsData, 1);

    const currentNumber =
        phones.length > 0 ? phones.find((n) => n.id === selectedNumber) || phones[0] : null;

    return {
        isConnected,
        isPaid,
        wabaLoading,
        wabaError,
        phones,
        wabaAccounts,
        analyticsData,
        selectedNumber,
        showConnect,
        currentNumber,
        setSelectedNumber,
        setShowConnect,
        totalSent,
        totalDelivered,
        deliveryRate,
    };
};
